import get from 'lodash/get';
import isEqual from 'lodash/isEqual';

// Determines if heatmap should be re-fetched
export const generateHeatmapDataImprint = (params, settings) => {
  const { resultName, hitSetKey, sortedMatrixName } = params;
  return {
    rowsType: get(settings, 'row.value'),
    colsType: get(settings, 'col.value'),
    cellOperation: get(settings, 'cellOperation'),
    showSubstances: get(settings, 'showSubstances'),
    resultName,
    hitSetKey,
    sortedMatrixName,
  };
};

export const validateHeatmapDataImprint = (heatmapDataImprint, params, settings) => {
  return isEqual(heatmapDataImprint, generateHeatmapDataImprint(params, settings));
};
